/** Чёрные теги категории «исследования» с обязательными блоками библиографии и источников изображений */
export const visualResearchTags = [
  "f9321d1337744e44831048435055ae54",
  "3h8ecj38fk554a5j439bm4l4ch27dh3g",
  "8d66025b74a44a2a8df40e7ef227f22c",
  "acb2f5d0e759439c8cd5aec44a1d8265",
  "b89ef799f371415e9078034ed57a8bde",
  "a89ef587f373265b9078034ed61b5cad",
  "03d3db96f1b3464594d13af36d1d0a20",
  "dc46c875129b4b23b9e487003468360f",
  "3da0ff46021846e18fdbe6ee6175e581",
  "6beb2b1ee8074d20bf0f7310ccb46538",
  "ea88d5d934fe471a9b6b8e7e4b4e5384",
  "5abd1aba612f42a8a7f16fc6091c9879",
  "40af99e8d2a8453eaa5662fb4607e256",
  "4a037be096c244e0a4d4f8e6ed6116ae",
  "b9ac761f373d4a01809f5589edee71ab",
  "7d293663afaa4611a0fd7121ea8aa8f5",
  "21ddb961def349dba84701d8e0080ffc",
  "8f7bd3da39a745dcb9adc2d73708aad2",
  "b945d199aa00490da2e1ac3c617143a7",
  "3d966cbbe9d5470a99e3befd63a16565",
  "463a68ef7a2f40328ff01e6cf04cdcb2",
  "cc2bf76ac7514e21abd9e0d07d1d57dc",
  "3d737faa5f894832ae0b43295fcf1281",
  "a078b15069e549a592f1b6faca2f6f54",
  "6c05621ddb7f4672a6be5c5aa4d71d64",
  "b85dd5a16fcd41cf87e292d5733d660f",
  "b88d2c4cf76843f588c5fd27c7c14256",
  "fa0e49893cc045768d3d2ea980c87c4f",
  "ba0efdd2ff53473eaa8b3318840ba4d7",
  "054bd42916e74391885837a9ba90d017",
];
/** Чёрные теги категории «исследования» с обязательными блоками библиографии и источников изображений */
export const visualResearchTags = [
  "f9321d1337744e44831048435055ae54",
  "3h8ecj38fk554a5j439bm4l4ch27dh3g",
  "8d66025b74a44a2a8df40e7ef227f22c",
  "acb2f5d0e759439c8cd5aec44a1d8265",
  "b89ef799f371415e9078034ed57a8bde",
  "a89ef587f373265b9078034ed61b5cad",
  "03d3db96f1b3464594d13af36d1d0a20",
  "dc46c875129b4b23b9e487003468360f",
  "3da0ff46021846e18fdbe6ee6175e581",
  "6beb2b1ee8074d20bf0f7310ccb46538",
  "ea88d5d934fe471a9b6b8e7e4b4e5384",
  "5abd1aba612f42a8a7f16fc6091c9879",
  "40af99e8d2a8453eaa5662fb4607e256",
  "4a037be096c244e0a4d4f8e6ed6116ae",
  "b9ac761f373d4a01809f5589edee71ab",
  "7d293663afaa4611a0fd7121ea8aa8f5",
  "21ddb961def349dba84701d8e0080ffc",
  "8f7bd3da39a745dcb9adc2d73708aad2",
  "b945d199aa00490da2e1ac3c617143a7",
  "3d966cbbe9d5470a99e3befd63a16565",
  "463a68ef7a2f40328ff01e6cf04cdcb2",
  "cc2bf76ac7514e21abd9e0d07d1d57dc",
  "3d737faa5f894832ae0b43295fcf1281",
  "a078b15069e549a592f1b6faca2f6f54",
  "6c05621ddb7f4672a6be5c5aa4d71d64",
  "b85dd5a16fcd41cf87e292d5733d660f",
  "b88d2c4cf76843f588c5fd27c7c14256",
  "fa0e49893cc045768d3d2ea980c87c4f",
  "ba0efdd2ff53473eaa8b3318840ba4d7",
  "054bd42916e74391885837a9ba90d017",
];
